"use strict";

var _interopRequireDefault = require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _zhjyPagination = _interopRequireDefault(require("@/components/zhjyPagination/zhjyPagination.vue"));
var _zhjyTable = _interopRequireDefault(require("@/components/table/zhjyTable.vue"));
var _funBtn = _interopRequireDefault(require("@/components/funBtn/funBtn.vue"));
var _works = require("@/api/works/works");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    return {
      minWidth: 200,
      multipleSelection: [],
      tableData: [],
      defaultColumn: [{
        name: "作品/课程名称",
        prop: "workName",
        isShow: true,
        width: "100"
      }, {
        name: "专家名称",
        prop: "name",
        isShow: true,
        width: "100"
      }, {
        name: "专家评分",
        prop: "totalScore",
        isShow: true,
        width: "100"
      }, {
        name: "专家评语",
        prop: "content",
        isShow: true,
        width: "100"
      }],
      options: [],
      funBtns: [],
      formatters: {
        status: [
        // {
        //   name: "待审核",
        //   value: "1"
        // },
        // {
        //   name: "审核未通过",
        //   value: "2"
        // },
        {
          name: "待分配",
          value: "3"
        }, {
          name: "评审中",
          value: "4"
        }, {
          name: "结束",
          value: "5"
        }],
        isPublish: [{
          name: "未发布",
          value: "0"
        }, {
          name: "已发布",
          value: "1"
        }]
      },
      modelData: {
        groupId: "",
        stageId: "",
        userName: "",
        year: "",
        status: "",
        isPublish: ""
      },
      queryGroup: [{
        label: "所属组别",
        type: "select",
        model: "groupId",
        options: [],
        placeholder: "所属组别",
        change: "matchChangegroup"
      }, {
        label: "所属阶段",
        type: "select",
        model: "stageId",
        options: [],
        placeholder: "所属阶段",
        change: "matchChangestage"
      }, {
        label: "姓名",
        type: "input",
        model: "userName",
        placeholder: "姓名"
      }, {
        label: "状态",
        type: "select",
        model: "status",
        options: [{
          name: "待审核",
          value: "1"
        }, {
          name: "审核未通过",
          value: "2"
        }, {
          name: "待分配",
          value: "3"
        }, {
          name: "评审中",
          value: "4"
        }, {
          name: "结束",
          value: "5"
        }],
        placeholder: "审核状态"
      },
      // {
      //   label: "发布状态",
      //   type: "select",
      //   model: "isPublish",
      //   options: [
      //     {
      //       name: "未发布",
      //       value: "0"
      //     },
      //     {
      //       name: "已发布",
      //       value: "1"
      //     }
      //   ],
      //   placeholder: "发布状态"
      // },
      {
        label: "年份",
        type: "select",
        model: "year",
        options: [],
        placeholder: "年份"
      }],
      checkBoxData: [],
      checkBoxData2: [],
      page: {
        pageNum: 1,
        pageSize: 10
      },
      total: null,
      //设置奖项弹框
      prizeDialogVisible: false,
      // 手动分配
      sdfpDia: false,
      prizeValue: "1",
      stageId: 10,
      worksIds: [],
      expertIds: [],
      queryValue: "",
      allCheckBoxs: []
    };
  },
  components: {
    ZhjyTable: _zhjyTable.default,
    FunBtn: _funBtn.default,
    ZhjyPagination: _zhjyPagination.default
  },
  created: function created() {
    // 获取评语
    this.getList();
  },
  methods: {
    getList: function getList() {
      var _this = this;
      (0, _works.getCommit)({
        worksId: this.$route.query.id
      }).then(function (res) {
        console.log(res);
        _this.tableData = res.data;
      });
    }
  }
};